if (!customElements.get('lht-gallery')) {
  customElements.define('lht-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-gallery-image]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const image = dialog.querySelector('img');
        image.src = link.href;
        image.alt = link.querySelector('img').alt;
        this.opener = link;
        dialog.showModal();
      }, options);
      dialog.querySelector('button').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }, options);
      dialog.addEventListener('close', () => this.opener?.focus(), options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
